function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.344 10.718 11.213 7.23a.4.4 0 0 1 0-.662l5.13-3.487a.4.4 0 0 1 .626.33V5.67H24.8a4.2 4.2 0 0 1 4.2 4.2v3.8a.4.4 0 0 1-.4.4h-2a.4.4 0 0 1-.4-.4v-3.2a2 2 0 0 0-2-2h-7.231v1.918a.4.4 0 0 1-.625.33ZM5.8 15.504h15.09v10.684H5.8V15.504Zm16.89-2.8H4a1 1 0 0 0-1 1v14.284a1 1 0 0 0 1 1h18.69a1 1 0 0 0 1-1V13.704a1 1 0 0 0-1-1Z"
  }));
};
var componentName = 'RotateLeftOutlined';
export var RotateLeftOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
RotateLeftOutlined.displayName = componentName;